import { render, staticRenderFns } from "./DeliverySheetBoard.vue?vue&type=template&id=1df684e0&scoped=true&"
import script from "./DeliverySheetBoard.vue?vue&type=script&lang=ts&"
export * from "./DeliverySheetBoard.vue?vue&type=script&lang=ts&"
import style0 from "./DeliverySheetBoard.vue?vue&type=style&index=0&id=1df684e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df684e0",
  null
  
)

export default component.exports